// extracted by mini-css-extract-plugin
export default {"inlineAdWrapper":"oQ-z","inlineTitle":"pQ-z","sponsoredAdsWrapper":"qQ-z","marketplaceRecosWrapper":"rQ-z"};